import { przezmorzeApi } from "../../../api/api";
import type {
  CustomerSummary,
  CustomerSummaryContactPerson,
  CustomerSummaryListResponse,
  LastOrderDateResponse,
} from "@przezmorze/api-types";
import { type ClientFilters, tagFilterValue } from "./clientFilters";

export type { CustomerSummary, CustomerSummaryContactPerson };

export async function listCustomerSummaries(
  filters: ClientFilters,
  abortSignal?: AbortSignal,
): Promise<CustomerSummary[]> {
  const response = await przezmorzeApi.get<CustomerSummaryListResponse>("/customers-overview/summaries", {
    params: toSearchParams(filters),
    signal: abortSignal,
  });
  return response.data.items;
}

export async function getLastOrderDate(customerId: string, abortSignal?: AbortSignal): Promise<string | null> {
  const response = await przezmorzeApi.get<LastOrderDateResponse>(`/customers-overview/${customerId}/last-order-date`, {
    signal: abortSignal,
  });
  return response.data.lastOrderDate;
}

/** Skips unset filters and repeats `tag`, `excludedTag` and `has` once per selected value. */
function toSearchParams({ tags, excludedTags, has, ...scalarFilters }: ClientFilters): URLSearchParams {
  const scalarEntries = Object.entries(scalarFilters)
    .map(([name, value]): [string, string] => [name, value.trim()])
    .filter(([, value]) => value !== "");
  const tagEntries = tags.map((tag): [string, string] => ["tag", tagFilterValue(tag)]);
  const excludedTagEntries = excludedTags.map((tag): [string, string] => ["excludedTag", tagFilterValue(tag)]);
  const hasEntries = has.map((value): [string, string] => ["has", value]);
  return new URLSearchParams([...scalarEntries, ...tagEntries, ...excludedTagEntries, ...hasEntries]);
}
